import { render, staticRenderFns } from "./TaxRegimeCatalog.vue?vue&type=template&id=b6a02752"
import script from "./TaxRegimeCatalog.vue?vue&type=script&lang=js"
export * from "./TaxRegimeCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6a02752')) {
      api.createRecord('b6a02752', component.options)
    } else {
      api.reload('b6a02752', component.options)
    }
    module.hot.accept("./TaxRegimeCatalog.vue?vue&type=template&id=b6a02752", function () {
      api.rerender('b6a02752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/TaxRegimeCatalog.vue"
export default component.exports